export function resizeRichTextImage(content: string, containerWidth: number) {
    content = content.replace(/<(\/?)([\w\-]+)([^>]*)>/gi, (tagHtml, _split, tagName, attrs) => {
        if (tagName === 'img') {
            const attrsReg = /([\w\-]*?)\s*=\s*(("([^"]*)")|('([^']*)')|([^\s>]+))/gi;
            let width = 0;
            let height = 0;
            attrs = attrs.replace(/\/$/, '');
            attrs = attrs.replace(attrsReg, (str: string, attr: string, val: string) => {
                if (attr === 'width') {
                    width = parseInt(val.replace(/\"/g, ''), 10);
                    return '';
                }
                if (attr === 'height') {
                    height = parseInt(val.replace(/\"/g, ''), 10);
                    return '';
                }
                return str;
            });

            if (width > containerWidth) {
                height = Math.round((containerWidth * height) / width);
                width = containerWidth;
            }
            if (width) {
                attrs += ` width="${width}"`;
            }
            if (height) {
                attrs += ` height="${height}"`;
            }
            tagHtml = `<img ${attrs} />`;
            return tagHtml;
        }
        return tagHtml;
    });
    return content;
}
